import { render, staticRenderFns } from "./DragonBoat.vue?vue&type=template&id=1a2ae1ee&scoped=true&"
import script from "./DragonBoat.vue?vue&type=script&lang=js&"
export * from "./DragonBoat.vue?vue&type=script&lang=js&"
import style0 from "./DragonBoat.vue?vue&type=style&index=0&id=1a2ae1ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2ae1ee",
  null
  
)

export default component.exports